"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
SearchService.$inject = ['api', '$q'];
function SearchService(api, $q) {
    var service = {};
    service.get = function (text) {
        return api.get('/b2b/search', { q: text });
    };
    return service;
}
exports.SearchService = SearchService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/search/services/search.js
// module id = 470
// module chunks = 0